/*
 ** DataStore 变量缓存器
 ** 方便我们在不同的类中访问和修改变量
 ** 相当于全局变量使用
 **
 ** map 使用方法
 ** import DataStore  from '@/global/storage/index.js';
 ** const userInfoInDataStore = DataStore.map.get('userInfo');
 ** DataStore.map.set('userInfo',storageUserInfo);
 **
 ** 同时封装使用 strorage、session、cookie
 ** storage
 ** session
 ** cookie
 */

// import MyCookie from "./cookie"; 有 BUG
import MyStorage from "./storage";
import MySession from "./session";
import Cookie from "js-cookie";

class DataStore {
  constructor() {
    this.init();
  }

  init() {
    this.map = new Map();
    this.storage = new MyStorage();
    this.session = new MySession();
  }

  static getInstance() {
    if (!DataStore.instance) {
      DataStore.instance = new DataStore();
    }
    return DataStore.instance;
  }

  getToken() {
    return Cookie.get("token");
  }

  setToken(token) {
    this.storage.set("token", token);
  }

  removeToken() {
    const DOMAIN = process.env.VUE_APP_DOMAIN;
    Cookie.remove("uid", { domain: DOMAIN });
    Cookie.remove("token", { domain: DOMAIN });
    const referer = window.location.href;
    const PASSPORT_PREFIX = "https://passport" + process.env.VUE_APP_DOMAIN;
    window.location.href = PASSPORT_PREFIX + "/?referer=" + referer;
  }

  clear() {
    localStorage.clear();
    sessionStorage.clear();
    this.removeToken();
  }
}

export default DataStore.getInstance();
